import { LOGIN_URL } from 'config';
import { produce } from 'immer';
import { memoize } from 'lodash-es';
import colors from 'style-utils/colors';
import { Theme } from 'theme';

export const modifyTrisTitleTheme: (globalTheme: Theme) => Theme = memoize(
  (globalTheme) =>
    produce(globalTheme, (draft) => {
      draft.trisTitle.mobile.title.fontWeight = 800;
    }),
);

const userDataEntryTheme = {
  userDataEntry: {
    root: {
      borderBottom: `1px solid ${colors.horizontalRulerColor}`,
      alignItems: '',
      padding: '16px 0 12px',
    },
    span1: {
      display: 'inline-block',
      height: '24px',
      letterSpacing: '0',
      fontSize: '14px',
      fontWeight: '400',
      fontFamily: 'var(--primary-font-family)',
      color: colors.blackTwelve,
    },
    span2: {
      display: 'inline-block',
      height: '24px',
      letterSpacing: '0',
      fontSize: '14px',
      fontWeight: '700',
      fontFamily: 'var(--secondary-font-family)',
      color: colors.blackTwelve,
    },
  },
};

export default userDataEntryTheme;
export function scrollToTargetAdjusted(
  target: string,
  offset: number,
  fallbackTimes: number = 40,
) {
  const element = document.getElementById(target);

  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition - offset;
    window.scrollTo({
      top: offsetPosition,
    });
  } else if (fallbackTimes > 0) {
    setTimeout(
      () => scrollToTargetAdjusted(target, offset, fallbackTimes - 1),
      50,
    );
  }
}

export const startModifyPasswordFlow: (
  accessData: {
    username: string;
    email: string;
    phonePrefix: string;
    phoneNumber: string;
  },
  channel?: number,
) => void = ({ username, email, phonePrefix, phoneNumber }, channel) =>
  (window.location.href = `${LOGIN_URL}RecuperaPassword?siteid=${
    channel ?? 62
  }&username=${username}&email=${email}&phonePrefix=${phonePrefix}&phone=${phoneNumber}&cancelcallbackurl=${
    window.location.href
  }&endcallbackurl=${window.location.href}`);
